import React, { useState } from "react";

// STYLES
import * as Style from "./EventEditStyle";

// LIBRARIES
import { Dayjs } from "dayjs";
import moment from "moment";

// MISC
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS
import DeleteIcon from "assets/Icons/DeletedIcon.svg";
import DefaultIcon from "assets/Icons/DefaultImage.svg";

// REDUX

// COMPONENTS
import DateInputAtom from "components/Atoms/DateInputAtom/DateInputAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import ButtonUpload from "components/Atoms/ButtonUploadAtom/ButtonUploadAtom";
import TextEditor from "components/TextEditor/TextEditor";

const EventEdit = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS
  const [startValue, setStartValue] = useState<Dayjs | null>(null);
  const [endValue, setEndValue] = useState<Dayjs | null>(null);
  const [selectedImages, setSelectedImages] = useState([]);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleSelectFile = (selectedIndex) => {
    let selectedImagesCopy = selectedImages.map((selectedImage, index) => {
      if (index === selectedIndex) {
        selectedImage.isCoverImage = true;
      } else {
        selectedImage.isCoverImage = false;
      }
      return selectedImage;
    });
    setSelectedImages(selectedImagesCopy);
  };

  const handleUploadFiles = (files: File[]) => {
    setSelectedImages([
      ...selectedImages,
      ...files.map((e) => ({ file: e, isCoverImage: false })),
    ]);
  };
  const handleRemove = (item) => {
    let newArray = [...selectedImages];
    let indexToRemove = newArray.indexOf(item);
    if (indexToRemove !== -1) {
      newArray.splice(indexToRemove, 1);
      setSelectedImages(newArray);
    }
  };
  const handleBytesToMegaBytes = (megabytes) => {
    return (megabytes / 1048576).toFixed(2);
  };
  return (
    <Style.Container>
      <Style.Title>Adauga eveniment</Style.Title>
      <Style.ContentContainer>
        <Style.DetailsContainer>
          <Style.InputContainer>
            <InputAtom label="Title" placeholder="Nume eveniment lorem ipsus" />
          </Style.InputContainer>
          <Style.InputContainer>
            <TextEditor label="Descriere" />
          </Style.InputContainer>
          <Style.DatesInputContainer>
            <Style.DateInputContainer>
              <DateInputAtom
                label="De la"
                value={startValue}
                setValue={setStartValue}
              />
            </Style.DateInputContainer>
            <Style.DateInputContainer>
              <DateInputAtom
                label="Pana la"
                value={endValue}
                setValue={setEndValue}
              />
            </Style.DateInputContainer>
          </Style.DatesInputContainer>
        </Style.DetailsContainer>
        <Style.UpdatePhotoContainer>
          <Style.AddPhotoContainer>
            <Style.ButtonUploadDescription>
              <Style.DescriptionTitle>
                Trageti si plasati fisierele aici
              </Style.DescriptionTitle>
              <Style.DescriptionText>
                Fisiere acceptate: .png; .jpg; .mp4; .m4v; .mov; .wmv
              </Style.DescriptionText>
              <Style.DescriptionText>
                Se pot plasa unul sau mai multe fisiere
              </Style.DescriptionText>
              <Style.DescriptionText>
                Selecteaza fisierul dorit pentru coperta
              </Style.DescriptionText>
            </Style.ButtonUploadDescription>
            <ButtonUpload
              handleUploadFiles={handleUploadFiles}
              onChange={(e) => {
                handleUploadFiles([...e.target.files]);
              }}
            />
          </Style.AddPhotoContainer>
          <Style.AddedPhotosContainer>
            <Style.ScrollBarContainer>
              {selectedImages &&
                selectedImages.map((selectedImage, index) => (
                  <Style.SelectedImageMapContainer
                    key={`uploaded-image--${index}`}
                  >
                    <Style.SelectedImageContainer>
                      <Style.SelectedImageDetailsContainer>
                        <Style.SelectedImage src={DefaultIcon} />
                        <Style.SelectedImageDetails>
                          <Style.SelectedImageName>
                            {selectedImage && selectedImage.file.name}
                          </Style.SelectedImageName>
                          <Style.SelectedImageDate>
                            {selectedImage &&
                              moment(selectedImage.file.lastModified).format(
                                "DD.MM.YYYY"
                              )}{" "}
                            /{" "}
                            {selectedImage &&
                              handleBytesToMegaBytes(selectedImage.file.size)}
                            MB
                          </Style.SelectedImageDate>
                        </Style.SelectedImageDetails>
                      </Style.SelectedImageDetailsContainer>
                      <Style.SelectedImageButtons>
                        <Style.SelectedImageChossedImage>
                          <Style.CheckboxContainer
                            onClick={() => handleSelectFile(index)}
                            checked={selectedImage.isCoverImage}
                          />
                          <Style.ChossedImageLabel>
                            Poza coperta
                          </Style.ChossedImageLabel>
                        </Style.SelectedImageChossedImage>
                        <Style.SelectedImageDeleteIcon
                          src={DeleteIcon}
                          onClick={() => handleRemove(selectedImage)}
                        />
                      </Style.SelectedImageButtons>
                    </Style.SelectedImageContainer>
                  </Style.SelectedImageMapContainer>
                ))}
            </Style.ScrollBarContainer>
          </Style.AddedPhotosContainer>
        </Style.UpdatePhotoContainer>
      </Style.ContentContainer>
      <Style.ButtonContainer>
        <ButtonAtom text="Vizualizeaza" type={ButtonTypes.MAIN_BUTTON} />
      </Style.ButtonContainer>
    </Style.Container>
  );
};

export default EventEdit;
